import React, { FC, Fragment, useEffect, useState, ChangeEvent } from 'react';
import { TextInput, Select, CheckboxInput } from '@td-client-frontend/common';
import { useDebounce } from 'use-debounce/lib';
import { ArgsInputProps, ArgsSelectProps, ArgsCheckboxProps } from '../../../../@types/TemplateOperators';

const ArgsInput: FC<ArgsInputProps> = ({ initialValue, onChange, placeholder = '', label, subLabel }) => {
  const [value, setValue] = useState<string>(initialValue);
  const [debounceValue] = useDebounce<string>(value, 750);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onChange(value), [debounceValue]);

  return (
    <Fragment>
      {label && <h3 className="w-48 mt-2">{label}</h3>}
      <div className="w-full max-w-xs">
        <TextInput placeholder={placeholder} value={value} onChange={handleChange} />
        {subLabel && <p className="mr-16 mt-2 text-sm">{subLabel}</p>}
      </div>
    </Fragment>
  );
};

const ArgsSelect: FC<ArgsSelectProps> = ({ argsSelectLabel, options, onChange, value, label, maxVisible = 3 }) => {
  return (
    <Fragment>
      {argsSelectLabel && <h3 className="w-48 mt-6">{argsSelectLabel}</h3>}
      <Select
        options={options}
        onChange={onChange}
        value={value}
        label={label}
        wraperClasses="flex flex-col flex-col-reverse w-full max-w-xs"
        labelClasses="mr-16 mt-2 text-sm"
        maxVisible={maxVisible}
      />
    </Fragment>
  );
};

const ArgsCheckbox: FC<ArgsCheckboxProps> = ({ checked, onChange, name, label, subLabel }) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked);

  return (
    <Fragment>
      {label && <h3 className="w-48 mt-2">{label}</h3>}
      <div className="h-12 w-full max-w-xs flex">
        <label className="flex flex-col justify-start items-start">
          <CheckboxInput name={name} checked={checked} onChange={handleChange} />
          {subLabel && <p className="mr-16 mt-2 text-sm">{subLabel}</p>}
        </label>
      </div>
    </Fragment>
  );
};

export { ArgsInput, ArgsSelect, ArgsCheckbox };
